"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const logger_1 = require("@almservices-cl/logger");
const config_consts_1 = require("../../Container/config.consts");
exports.default = (namespace) => {
    return (c) => c.get(config_consts_1.IS_LOGGER_ENABLED) ? new logger_1.ConsoleLogger(namespace) : new logger_1.NullLogger();
};
//# sourceMappingURL=loggerFactory.js.map